import type { EntityIdentityNormalizationState } from '@cli-types/core-engine/schema-reader.js'
import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { createGeneratedSlugFieldForTitle } from './create-generated-slug-field-for-title.js'
import { isEntitySlugField } from './is-entity-slug-field.js'
import { isGeneratedSchemaTitleField } from './is-generated-schema-title-field.js'
import { normalizeEntitySlugField } from './normalize-entity-slug-field.js'
import { orderEntityIdentityFields } from './order-entity-identity-fields.js'

export function normalizeEntityIdentityFields(
  fields: SchemaField[],
  rootFields: SchemaField[],
  state: EntityIdentityNormalizationState
): SchemaField[] {
  const normalizedFields: SchemaField[] = []

  for (const field of fields) {
    if (isEntitySlugField(field)) {
      if (state.keptAuthoredSlugField) continue
      state.keptAuthoredSlugField = true
      normalizedFields.push(normalizeEntitySlugField(field, state.sourceField))
      continue
    }

    if ((field.type === 'group' || field.type === 'section') && field.fields) {
      normalizedFields.push({
        ...field,
        fields: normalizeEntityIdentityFields(field.fields, rootFields, state)
      })
      continue
    }

    if (field.type === 'tabs' && field.tabs) {
      normalizedFields.push({
        ...field,
        tabs: field.tabs.map((tab) => ({
          ...tab,
          fields: normalizeEntityIdentityFields(tab.fields ?? [], rootFields, state)
        }))
      })
      continue
    }

    normalizedFields.push(field)

    if (
      !state.hasAuthoredSlugField &&
      !state.generatedSlugInserted &&
      isGeneratedSchemaTitleField(field)
    ) {
      normalizedFields.push(createGeneratedSlugFieldForTitle(rootFields, field))
      state.generatedSlugInserted = true
    }
  }

  return orderEntityIdentityFields(normalizedFields)
}
